// todo implement me
export const useBiometry = () => ({
    saveCredentials: () => {},
    loadCredentials: () => {},
    clearSavedCredentials: () => {},
    showSaveCredentialsAlert: () => {},
    biometryInfo: {},
    isSupportingBiometry: false
})
